<div [formGroup]="form" class="row">
  <div class="form-group col-6">
    <custom-select
      [filterEnabled]="true"
      [labelText]="'Elemento'"
      [bordered]="true"
      name="damageElement"
      id="damageElement"
      formControlName="damageElement"
      [(sourceList)]="_damageElementList"
      required
    ></custom-select>
  </div>
  <div class="form-group col-6">
    <label for="quantity">Cantidad</label>
    <input type="number"
      name="quantity"
      [customFocus]="true"
      formControlName="quantity"
      (input)="updateValuesAndValidations(form);limitDecimalPlaces($event)"
      class="form-control" 
      id="quantity"
      pattern="^([.]?[0-9.]+)"
      [customMin]=".1"
      step=".01"
      [customMax]="99999999"
      (paste)="_formValidatorService.validateOnlyNumberAndDot($event)"
      (keypress)="($event.charCode == 46 || ($event.charCode >= 48 && $event.charCode <= 57))"
      required/>
  </div>
  <div class="form-group col-12">
    <label for="comments">Comentarios</label>
    <textarea
      type="text" 
      customFocus 
      maxlength="255"
      name="comments"
      formControlName="comments"
      rows="2"
      class="form-control" 
      id="comments" 
      [placeholder]="'Comentarios'"
    ></textarea>
  </div>
</div>
